/* eslint-disable import/prefer-default-export */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import MaskedInput from 'react-text-mask';
import { createNumberMask } from 'text-mask-addons';
import styles from '../form-fields.module.css';

interface CurrencyMaskOptions {
    prefix: string;
    suffix: string;
    allowDecimal: boolean;
    decimalSymbol: string;
    decimalLimit: string;
    allowLeadingZeroes: boolean;
    integerLimit: number;
}

interface InputCurrencyProps {
    id: string;
    name: string;
    value: string;
    handler: (e: React.FormEvent<HTMLInputElement>) => void;
    required?: boolean;
    formRow?: boolean;
    disabled?: boolean;
    maskOptions?: CurrencyMaskOptions;
}

const defaultMaskOptions = {
    prefix: '$',
    suffix: '',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: ',',
    allowDecimal: true,
    decimalSymbol: '.',
    decimalLimit: 2, // how many digits allowed after the decimal
    integerLimit: 15, // limit length of integer numbers
    allowNegative: false,
    allowLeadingZeroes: false,
};

export const Currency: React.FC<InputCurrencyProps> = ({
    id,
    name,
    value,
    handler,
    formRow,
    maskOptions,
    required = false,
    disabled = false,
}) => {
    const { t } = useTranslation(['common']);
    const currencyMask = createNumberMask({
        ...defaultMaskOptions,
        ...maskOptions,
    });

    return (
        <>
            <label className={styles.InputElementLabel} htmlFor={id} data-qa={`currency-label-input-${id}`}>{`${name} ${
                required ? `(${t('common:required')})` : ''
            }`}</label>
            <MaskedInput
                className={`${styles.InputElement} ${formRow ? styles.FormRow : ''}`}
                id={id}
                name={name}
                value={value}
                required={required}
                mask={currencyMask}
                inputMode="decimal"
                onChange={handler}
                disabled={disabled}
                data-qa={`form-field-currency-input-${id}`}
            />
        </>
    );
};
